document.addEventListener('DOMContentLoaded', function () {
    const variantIdToHide = '49638362349867'; // Replace with your specific Variant ID
    const addToCartButton = document.querySelector('[name="add"]'); // Adjust if your theme uses a different selector
    const variantInput = document.querySelector('[name="id"]');
    const customMessage = document.createElement('p');
    const quantity = document.querySelector('.product-form__quantity');
    const shopify_payment_button = document.querySelector('.shopify-payment-button');
    customMessage.innerHTML = '<a href="/pages/contact" class="quote_btn">Email For Price</a>';
    customMessage.style.display = 'none';
    customMessage.style.color = 'red'; // Optional styling
    addToCartButton.parentNode.insertBefore(customMessage, addToCartButton);

    if (variantInput && addToCartButton) {
      variantInput.addEventListener('change', function () {
        if (this.value === variantIdToHide) {
          addToCartButton.style.display = 'none';
          quantity.style.display = 'none';
          shopify_payment_button.style.display = 'none';
          customMessage.style.display = 'block';
        } else {
          addToCartButton.style.display = 'block';
          quantity.style.display = 'block';
          shopify_payment_button.style.display = 'block';
          customMessage.style.display = 'none';
        }
      });

      // Initial check on page load
      if (variantInput.value === variantIdToHide) {
        addToCartButton.style.display = 'none';
        quantity.style.display = 'none';
        shopify_payment_button.style.display = 'none';
        customMessage.style.display = 'block';
      }
    }
  });